export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
  },
  {
    title: that.$l('INDEX.table_label_image') || '图片',
    field: 'displayImageUrl',
    width: 80,
    align: 'center',
    fixed: 'left',
    slots: { default: 'displayImageUrl' },
  },
  {
    title: '产品名称',
    field: 'displaySkuName',
    minWidth: 220,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displaySkuName' },
  },
  {
    title: '产品编号',
    field: 'displaySkuNo',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displaySkuNo' },
  },
  {
    title: '采购订单',
    field: 'hxPurchaseNo',
    minWidth: 220,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayPurchase' },
  },
  {
    title: '采购单价',
    field: 'purchasePrice',
    minWidth: 80,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: '采购数量',
    field: 'purchaseQty',
    minWidth: 80,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: '可出货数量',
    field: 'invQty',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: '装箱入数',
    field: 'inCtnQty',
    width: 80,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: '纸箱',
    field: 'displayBox',
    minWidth: 160,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayBox' },
  },
]
